import React, { useState } from 'react'
import useForm from './../../hooks/useForm'
import { ref, set, onValue, push, remove, update } from 'firebase/database'
import database from '../../firebase/base'

const INITIAL_STATE = {
    name:'',
}

const AjouterEntreprise = () => {
    const { values, handleChange } = useForm(INITIAL_STATE)

    const handleSave = (name) => {
        const data = {name:name}
        try {
            const postListRef = ref(database, 'administrateur/' + name + '/profil')
            const newPostRef = push(postListRef)
            set(newPostRef, data)
        } catch {
            console.log('Il y a une erreur dans l ecriture')
        }
    }

    return (
        <div className='m-3 text-center'>
            <div className='mt-3'>
                Page ajouter entreprise
            </div>
            <input name='name' placeholder='nom' value={values.name} onChange={handleChange} className='px-2 mt-3' />
            <button type="button" className="btn btn-primary" onClick={() => handleSave(values.name)}>Enregistrer</button>
        </div>
    )
}

export default AjouterEntreprise
